import { PreguntasTipoEnum } from "@shared/enums";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PREGUNTA_PADRE } from "../constantesImportador";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaRangeImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.NUMERIC_IN_RANGE;
    }

    public testear(datos: DatosPreguntaImportador[], esUltima: boolean = false): boolean {
        let pasoTests = super.testear(datos, esUltima);
        const preguntaPadre = datos[PREGUNTA_PADRE];
        if (preguntaPadre.item != null) {
            pasoTests = false;
            this.errores.push(`Los datos de la pregunta ${preguntaPadre.idPregunta} deben ir en ##Min/Max y no en ##Items`);
        }
        if (preguntaPadre.max == null || preguntaPadre.min == null || preguntaPadre.step == null) {
            pasoTests = false;
            this.errores.push(`Error de sintaxis en ##Min/Max en la pregunta ${preguntaPadre.idPregunta}`);
        }
        return pasoTests;
    }
}
